export enum LikeTypes {
  COMMENTS = 'comments',
  PRODUCTS = 'products',
  BRANDS = 'brands'
}
